import React from 'react'
import {ProsEditObs} from "../../prodect/ProsEditObs";
import * as prosConnect from "../../prodect/ProsConnect";

/**
 * @param {Props} props
 */
function CreateEditObsModal(props) {
    return <ProsEditObs
        refObs={props.obs ? props.obs : undefined}
        saveObs={props.obs
            ? obs => prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([obs])
            : (obs, reportId) => prosConnect.getActiveProject().awaitAddObsWithAttrs(obs, reportId)
        }
        cancelEdit={() => props.close()}
        deleteObs={props.obs
            ? () => prosConnect.getActiveProject().awaitRemoveItem(props.obs)
            : undefined
        }
        report={props.report ? props.report : undefined}
        attrs={props.attrs ? props.attrs : {}}
    />
}

/**
 * @param {import('../../components/Modal').ModalContext} modalContext
 * @param {Obs | undefined} obs
 */
export function openCreateEditObsModal(modalContext, obs, report, props) {
    modalContext.openModal({
        heading: obs && obs.obj_id ? 'Muokkaa kirjausta' : 'Lisää kirjaus',
        content: <CreateEditObsModal obs={obs} report={report} attrs={props.attrs || {}} close={()=> modalContext.closeModal()} />,
        helpContext: 'obsSettings'
    })
}